export function isInIndexingContext(): boolean {
    if(isInPromotionWorkerContext()) {
        return true;
    }

    if(typeof window === "undefined") { // Workers
        return false;
    }

    if(window.location.pathname === "/sell/display") { // Customer display
        return false;
    }

    return true;
}

export function isInUploadWorkerContext(): boolean {
    if(typeof window !== "undefined") {
        return false;
    }

    return (globalThis as unknown as DedicatedWorkerGlobalScope)?.name === "Shopfront Uploader";
}

export function isInPromotionWorkerContext(): boolean {
    if(typeof window !== "undefined") {
        return false;
    }

    return (globalThis as unknown as DedicatedWorkerGlobalScope)?.name === "Shopfront Promotions";
}
